import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "museo-slab, sans-serif",
  },
});

export default theme;
